// react
import React, { useEffect, useState } from "react";
// MATERIAL-UI
import { Grid, Typography } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
// ASSESTS
import { MarketOptionsStyles } from "./styles/MarketOptions.styles";
import { MarketOptionsProps } from "./types";
import GA from "src/analytics/googleAnalytics";
import { useAppDispatch } from "src/store/store";
import {
  setMarketTablePage,
  setMarketType,
  setTriggerRefetch,
  toggleFilterOptions,
  useMarketsState,
} from "src/store/features/markets.slice";
import { trackEvent } from "src/Amplitude";

type alignmentOptions =
  | "All"
  | "Biggest gainers"
  | "Recently added"
  | "Watchlist"
  | "Portfolio"
  | "Alerts";

const MarketOptions = (props: MarketOptionsProps) => {
  const { links } = props;
  const { filterOption } = useMarketsState();
  const classes = MarketOptionsStyles();
  const dispatch = useAppDispatch();

  const [alignment, setAlignment] = useState(links[0]);

  const handleChange = (event: React.MouseEvent<HTMLElement>, newAlignment: alignmentOptions) => {
    if (newAlignment !== null) {
      dispatch(setTriggerRefetch(true));
      setAlignment(newAlignment);
      dispatch(toggleFilterOptions(newAlignment));
      dispatch(setMarketType(newAlignment));
      dispatch(setMarketTablePage(1));
      GA.marketOption(newAlignment);
    }
  };

  useEffect(() => {
    if (filterOption != null) {
      dispatch(setTriggerRefetch(true));
      setAlignment(filterOption);
      dispatch(toggleFilterOptions(filterOption));
      dispatch(setMarketType(filterOption as alignmentOptions));
      dispatch(setMarketTablePage(1));
      GA.marketOption(filterOption);
    }
  }, [filterOption]);

  return (
    <Grid container alignItems="center" className={classes.container}>
      {links.map((link) => (
        <Grid key={link} item>
          <ToggleButtonGroup
            color="secondary"
            value={alignment}
            exclusive
            onChange={handleChange}
            className={classes.linksContainer}>
            <ToggleButton
              value={link}
              className={classes.link}
              onClick={() => trackEvent(`Select_Markets_Page`, { link })}>
              <Typography
                sx={{
                  textTransform: "none",
                  fontWeight: "semibold",
                }}>
                {link}
              </Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      ))}
    </Grid>
  );
};

export default MarketOptions;
